"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);

 const editorRoute = (orgKey, formKey) =>
  _routes.makeRoute.call(void 0, _routes2.default.FORMS.EDITOR, { orgKey, formKey }); exports.editorRoute = editorRoute

/* The phone scan page's full link, for the QR code. */
 const scanLink = (orgKey, formKey) =>
  `${window.location.origin}/#${_routes.makeRoute.call(void 0, _routes2.default.FORMS.SCAN, { orgKey, formKey: formKey || undefined })}`; exports.scanLink = scanLink

/* "today", "yesterday" or "Oct 3". */
 const dayText = (time) => {
  const m = _moment2.default.call(void 0, time)
  if (m.isSame(_moment2.default.call(void 0, ), 'day')) return 'today'
  if (m.isSame(_moment2.default.call(void 0, ).subtract(1, 'day'), 'day')) return 'yesterday'
  return m.format(m.isSame(_moment2.default.call(void 0, ), 'year') ? 'MMM D' : 'MMM D, YYYY')
}; exports.dayText = dayText

 const pluralize = (n, one, many) => `${n} ${n === 1 ? one : many}`; exports.pluralize = pluralize

/* Runs fn at most once per `ms`, the last call always running. Live notices
 * arrive up to twice a second a page while fields are found. */
 const throttle = (fn, ms) => {
  let timer = null
  let last = 0
  const run = () => {
    timer = null
    last = Date.now()
    fn()
  }
  const call = () => {
    if (timer) return
    const wait = last + ms - Date.now()
    if (wait <= 0) run()
    else timer = setTimeout(run, wait)
  }
  call.cancel = () => { if (timer) clearTimeout(timer); timer = null }
  return call
}; exports.throttle = throttle
